import React from 'react'

const hfssStatus = hfssFlag => {
  const hfssIndicator = <span className="c-hfss">YES</span>
  return hfssFlag === '1' ? hfssIndicator : ''
}

export default hfssStatus
